import { post, postFd } from "@utils/axios";

const Api = "update-profile";

export const updateProfiles = (payload) => {
  return postFd(Api + "/", payload);
}
export const changePasswordReq = (payload) => {
  return post("change-password", payload);
}